import Helpers from "commons/helpers";
import Constants from "constants/index";
import IdentityService from "./identity.service";

class RoleService extends IdentityService {

    public getAll = async (data: { status: number[]; clientId?: string; organizationId?: string }) => {
        const query = Helpers.handleFormatParams(data);
        const result = await this.api.get({
            path: Constants.ApiPath.ROLE.GET_ALL + `${query ? "?" : ""}${query}`,
        });
        return result.data.result;
    };

}

export default RoleService;
